import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

// FontAwesome
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEye, faEyeSlash, faLock } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-password-input',
  imports: [FontAwesomeModule, ReactiveFormsModule],
  templateUrl: './password-input.component.html',
  styleUrl: './password-input.component.scss'
})
export class PasswordInputComponent {
  readonly control = input.required<FormControl>();
  readonly placeholder = input('Password');
  readonly id = input('password');
  readonly showValidatorCSS = input(false);

  faLock = faLock;
  faEye = faEye;
  faEyeSlash = faEyeSlash;

  showPassword: boolean = false;
}
